module.exports = __webpack_public_path__ + "static/media/globe.ce2ce4cd.svg";